import {put, takeLatest, call} from 'redux-saga/effects'
import * as optionService from "../../../../services/optionService.js"

import {
    CHANGE_OPTIONS_VISIBILITY,
    CHANGE_OPTIONS_VISIBILITY_SUCCESS,
    CHANGE_OPTIONS_VISIBILITY_ERROR,
}
    from "../../../actions/menu/options"

function* changeOptionsVisibilitySaga(action) {
    try {
         yield call(optionService.ChangeOptionsVisibility, action.payload)
        yield put({
            type: CHANGE_OPTIONS_VISIBILITY_SUCCESS,
            payload: action.payload.data
        });


    } catch (error) {
        yield put({
            type: CHANGE_OPTIONS_VISIBILITY_ERROR,error: error.data
        });
    }
}


export function* changeOptionsVisibilitySagaWatcher() {
    yield takeLatest(CHANGE_OPTIONS_VISIBILITY, changeOptionsVisibilitySaga);
}